module.exports = __webpack_public_path__ + "1792395595471/fonts/line-awesome.4d42f5f.ttf";